import React from "react";
import Slider from "react-slick";
import { Hero, HeroProps, Heros } from "./interfaces/hero";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Container from "../Common/Container";
import Button from "../primitives/Button";
import "./styles.css";
import Text from "../Common/Text";
import { DEFAULDATA } from "./DefaultData";
import Image from "../Common/Image";

const Hero = ({
  data = DEFAULDATA,
  currentSlide,
  onChange,
  ImageProvider,
}: HeroProps) => {
  const settings = {
    dots: true,
    infinite: true,
    autoplaySpeed: parseInt(data?.time || "10", 10) * 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>,
  };

  if (data?.heros?.length === 1) {
    return (
      <div>
        {data?.heros?.map((item) => (
          <Slide
            item={item}
            key={item.id}
            onChange={onChange}
            data={data}
            idx={0}
            ImageProvider={ImageProvider}
          />
        ))}
      </div>
    );
  }

  if (currentSlide) {
    return (
      <div>
        <Slide
          item={data?.heros?.[currentSlide]}
          idx={0}
          data={data}
          ImageProvider={ImageProvider}
        />
      </div>
    );
  }

  return (
    <div className="relative">
      <Slider {...settings}>
        {data?.heros?.map((item, idx) => (
          <Slide
            item={item}
            key={item.id}
            idx={idx}
            onChange={onChange}
            data={data}
            ImageProvider={ImageProvider}
          />
        ))}
      </Slider>
    </div>
  );
};

const Slide = ({
  item,
  idx,
  onChange,
  data,
  ImageProvider,
}: {
  item: Hero;
  idx: number;
  onChange?: (value: any, id: string, idx?: number) => void;
  data: Heros;
  ImageProvider: any;
}) => {
  const calculateOpacity = (opacity: number) => {
    if (opacity == 1 || !opacity) {
      return {};
    } else if (opacity > 1) {
      const value = opacity - 1;
      return {
        background: "black",
        opacity: value,
      };
    } else {
      const value = opacity;

      return {
        background: "white",
        opacity: value,
      };
    }
  };

  return (
    <div className="relative">
      <div
        className="absolute z-[2] w-full h-full flex items-center"
        style={{
          textAlign: (item?.alling as "left" | "center" | "right") || "left",
        }}
      >
        <Container className="w-full">
          <Text
            editor={!!onChange}
            id="title"
            onChange={(val: any) => {
              if (onChange) {
                let heroes = data.heros;

                heroes = heroes.map((x) => {
                  if (x.id === item.id) {
                    return { ...x, title: val };
                  }
                  return x;
                });
                onChange?.(heroes, "heros", idx);
              }
            }}
          >
            {item?.title}
          </Text>
          <Button {...item.button} className="mt-5" />
        </Container>
      </div>
      <div
        className="absolute w-full h-full top-0 left-0  z-[1]"
        style={calculateOpacity(parseFloat(item?.opacity || "0.5") || 0.5)}
      ></div>
      <Image
        className="object-cover  w-full h-[90vh] "
        desktop={item.image?.desktop}
        alt=""
        ImageProvider={ImageProvider}
        height={"90vh"}
        width={"100%"}
      />
    </div>
  );
};
export default Hero;
